import { persistor } from "../Redux/store";
import { resetAuthSession } from "../Redux/Slice/authSlice";
import { resetOrganisationAction } from "../Redux/Action/organisationAction";
import { LogotAction, userLogTimeUpdateAction } from "../Redux/Action/authAction";
import { clearPlatformVisitMarkers } from "./visitTracking";
import { msalInstance } from "./msalConfig";

let isPerformingLogout = false;

/**
 * Universal, guaranteed logout utility.
 * Always clears client session, redux-persist, and storage regardless of network / API status.
 *
 * @param {Function} dispatch - Redux dispatch function
 * @param {Object} [userData] - Current user data object (optional)
 * @param {number} [hours=0] - Active session hours to sync (optional)
 */
export const performLogout = async (dispatch, userData = null, hours = 0) => {
  if (isPerformingLogout) return;
  isPerformingLogout = true;

  // 1. Fire activity log time update if user has activityId (Non-blocking / best effort)
  if (userData?.activityId && dispatch) {
    try {
      const daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      const currentDayName = daysOfWeek[new Date().getDay()];
      const payload = {
        date: new Date(),
        hours: hours || 0,
        id: userData.activityId,
        day: currentDayName,
      };
      await dispatch(userLogTimeUpdateAction(payload));
    } catch (error) {
      console.warn("Failed to update activity time on logout:", error);
    }
  }

  // 2. Call backend logout endpoint (Non-blocking / best effort)
  if (dispatch) {
    try {
      await dispatch(LogotAction());
    } catch (error) {
      console.warn("Backend logout request failed:", error);
    }
  }

  // 3. Clear MSAL / SSO cache if available
  try {
    if (msalInstance && typeof msalInstance.clearCache === "function") {
      msalInstance.clearCache();
    }
  } catch (error) {
    console.warn("Failed to clear MSAL cache:", error);
  }

  // 4. Reset Redux states & Purge redux-persist
  try {
    clearPlatformVisitMarkers();
    if (dispatch) {
      dispatch(resetAuthSession());
      dispatch(resetOrganisationAction());
    }
    if (persistor && typeof persistor.purge === "function") {
      await persistor.purge();
    }
  } catch (error) {
    console.warn("Failed to purge Redux persistor:", error);
  }

  // 5. Clean all browser storage keys completely
  try {
    sessionStorage.clear();
    localStorage.clear();
  } catch (error) {
    console.warn("Failed to clear browser storage:", error);
  }

  // 6. Force hard-redirect to root landing/login page
  window.location.replace("/");
};
